import { render, staticRenderFns } from "./TermsAcceptForm.vue?vue&type=template&id=3aeb90d9&scoped=true"
import script from "./TermsAcceptForm.vue?vue&type=script&lang=js"
export * from "./TermsAcceptForm.vue?vue&type=script&lang=js"
import style0 from "./TermsAcceptForm.vue?vue&type=style&index=0&id=3aeb90d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb90d9",
  null
  
)

export default component.exports